import { h } from 'preact'

import { useEffect, useState } from 'preact/hooks'

import sendEventTracking from '@utils/stats/sendEventTracking'

import {
  COOKIE_STATUS,
  COOKIE_SETTING_TYPE,
  IS_ACCEPT_CONSENT_BANNER,
} from '@configs'

import {
  refreshCookieSetting,
  setCookieSetting,
} from '../utils/sanookHubHelper'
import sendEventTrackingButton from '../utils/sendEventTrackingButton'

import updateSaAndDcCookie from '../utils/updateSaAndDcCookie'
import updateAdsCookie from '../utils/updateAdsCookie'

import Template from './Template'

const { performance, targeting, advertising } = COOKIE_SETTING_TYPE

export default function CookieSettingContainer({
  cookieSetting,
  isOpenCookieSetting,
  setIsOpenCookieSetting,
  setShouldShowConsentBanner,
}) {
  const [isAcceptPerformance, setIsAcceptPerformance] = useState(true)
  const [isAcceptTargeting, setIsAcceptTargeting] = useState(true)
  const [isAcceptAdvertising, setIsAcceptAdvertising] = useState(true)

  const [isShowDetailSanookWebsiteCookie, setIsShowDetailSanookWebsiteCookie] =
    useState(false)
  const [isShowDetailPerformanceCookie, setIsShowDetailPerformanceCookie] =
    useState(false)
  const [isShowDetailTargetingCookie, setIsShowDetailTargetingCookie] =
    useState(false)
  const [isShowDetailAdvertisingCookie, setIsShowDetailAdvertisingCookie] =
    useState(false)

  useEffect(() => {
    if (cookieSetting === undefined || cookieSetting === null) {
      return
    }

    setIsAcceptPerformance(cookieSetting[performance] !== false)
    setIsAcceptTargeting(cookieSetting[targeting] !== false)
    setIsAcceptAdvertising(cookieSetting[advertising] !== false)
  }, [cookieSetting])

  const onTogglePerformance = () => {
    setIsAcceptPerformance((prev) => !prev)
  }

  const onToggleTargeting = () => {
    setIsAcceptTargeting((prev) => !prev)
  }

  const onToggleAdvertising = () => {
    setIsAcceptAdvertising((prev) => !prev)
  }

  const onToggleDetailSanookWebsiteCookie = () => {
    setIsShowDetailSanookWebsiteCookie((prev) => !prev)
  }

  const onToggleDetailPerformanceCookie = () => {
    setIsShowDetailPerformanceCookie((prev) => !prev)
  }

  const onToggleDetailTargetingCookie = () => {
    setIsShowDetailTargetingCookie((prev) => !prev)
  }

  const onToggleDetailAdvertisingCookie = () => {
    setIsShowDetailAdvertisingCookie((prev) => !prev)
  }

  const onCloseModal = () => {
    sendEventTracking({
      eventCategory: 'gdprnoti',
      eventAction: 'modal',
      eventLabel: 'gdprnoti-setting-close',
    })

    setIsOpenCookieSetting(false)
  }

  const onClickOutsideModal = () => {
    setIsOpenCookieSetting(false)
  }

  const onAcceptAll = () => {
    sendEventTracking({
      eventCategory: 'gdprnoti',
      eventAction: 'modal',
      eventLabel: 'gdprnoti-setting-acceptcookies',
    })

    sendEventTrackingButton({
      isAcceptPerformance: true,
      isAcceptTargeting: true,
      isAcceptAdvertising: true,
    })

    setCookieSetting({
      ...cookieSetting,
      [IS_ACCEPT_CONSENT_BANNER]: true,
      [performance]: true,
      [targeting]: true,
      [advertising]: true,
    })

    refreshCookieSetting()

    updateSaAndDcCookie(COOKIE_STATUS.ACCEPT)
    updateAdsCookie(COOKIE_STATUS.ACCEPT)

    setShouldShowConsentBanner(false)
    setIsOpenCookieSetting(false)
  }

  const onSave = () => {
    sendEventTracking({
      eventCategory: 'gdprnoti',
      eventAction: 'modal',
      eventLabel: 'gdprnoti-setting-save',
    })

    sendEventTrackingButton({
      isAcceptPerformance,
      isAcceptTargeting,
      isAcceptAdvertising,
    })

    setCookieSetting({
      ...cookieSetting,
      [IS_ACCEPT_CONSENT_BANNER]: true,
      [performance]: isAcceptPerformance,
      [targeting]: isAcceptTargeting,
      [advertising]: isAcceptAdvertising,
    })

    refreshCookieSetting()

    updateSaAndDcCookie(
      isAcceptAdvertising ? COOKIE_STATUS.ACCEPT : COOKIE_STATUS.OPT_OUT,
    )
    updateAdsCookie(
      isAcceptAdvertising ? COOKIE_STATUS.ACCEPT : COOKIE_STATUS.OPT_OUT,
    )

    setShouldShowConsentBanner(false)
    setIsOpenCookieSetting(false)
  }

  return (
    <Template
      isOpenCookieSetting={isOpenCookieSetting}
      isAcceptPerformance={isAcceptPerformance}
      isAcceptTargeting={isAcceptTargeting}
      isAcceptAdvertising={isAcceptAdvertising}
      onTogglePerformance={onTogglePerformance}
      onToggleTargeting={onToggleTargeting}
      onToggleAdvertising={onToggleAdvertising}
      isShowDetailSanookWebsiteCookie={isShowDetailSanookWebsiteCookie}
      isShowDetailPerformanceCookie={isShowDetailPerformanceCookie}
      isShowDetailTargetingCookie={isShowDetailTargetingCookie}
      isShowDetailAdvertisingCookie={isShowDetailAdvertisingCookie}
      onToggleDetailSanookWebsiteCookie={onToggleDetailSanookWebsiteCookie}
      onToggleDetailPerformanceCookie={onToggleDetailPerformanceCookie}
      onToggleDetailTargetingCookie={onToggleDetailTargetingCookie}
      onToggleDetailAdvertisingCookie={onToggleDetailAdvertisingCookie}
      onCloseModal={onCloseModal}
      onClickOutsideModal={onClickOutsideModal}
      onAcceptAll={onAcceptAll}
      onSave={onSave}
    />
  )
}
